import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertAhjFeeScheduleMutationVariables = Types.Exact<{
  object: Types.Ahj_Fee_Schedules_Insert_Input;
}>;


export type InsertAhjFeeScheduleMutation = { __typename?: 'mutation_root', insert_ahj_fee_schedules_one?: { __typename?: 'ahj_fee_schedules', id: any } | null };


export const InsertAhjFeeScheduleDocument = gql`
    mutation insertAhjFeeSchedule($object: ahj_fee_schedules_insert_input!) {
  insert_ahj_fee_schedules_one(object: $object) {
    id
  }
}
    `;
export type InsertAhjFeeScheduleMutationFn = Apollo.MutationFunction<InsertAhjFeeScheduleMutation, InsertAhjFeeScheduleMutationVariables>;

/**
 * __useInsertAhjFeeScheduleMutation__
 *
 * To run a mutation, you first call `useInsertAhjFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAhjFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAhjFeeScheduleMutation, { data, loading, error }] = useInsertAhjFeeScheduleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertAhjFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<InsertAhjFeeScheduleMutation, InsertAhjFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAhjFeeScheduleMutation, InsertAhjFeeScheduleMutationVariables>(InsertAhjFeeScheduleDocument, options);
      }
export type InsertAhjFeeScheduleMutationHookResult = ReturnType<typeof useInsertAhjFeeScheduleMutation>;
export type InsertAhjFeeScheduleMutationResult = Apollo.MutationResult<InsertAhjFeeScheduleMutation>;
export type InsertAhjFeeScheduleMutationOptions = Apollo.BaseMutationOptions<InsertAhjFeeScheduleMutation, InsertAhjFeeScheduleMutationVariables>;